import React from "react";
import Counter from "@/modules/frontend/components/Counter";
import { motion } from "framer-motion";

const Statistics = React.memo(() => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (
    <section className="statistics-wrape">
      <div className="inner-pad">
        <motion.div className="statistics-content animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={6} duration={2} decimals={0} className="add-plus" /> millions
            </span>
            <p>
              Global Buyers
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={13} duration={2} decimals={0} className="add-plus" /> millions
            </span>
            <p>
              Global Shipments
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content animation-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={27} duration={2} decimals={0} className="add-plus" /> thousands
            </span>
            <p>
              Global Suppliers
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content big animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={80} duration={2} className="add-plus" /> Countries
            </span>
            <p>
              Globally Serve
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content big animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={750} duration={2} className="add-plus" /> Global
            </span>
            <p>
              Logistic Partners
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content big animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter end={350} duration={2} className="add-plus" /> World Wide
            </span>
            <p>
              Cities & Ports Covered
            </p>
          </div>
        </motion.div>
        <motion.div className="statistics-content big animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          custom={0.5}
          variants={fadeUpVariant}
        >
          <div>
            <span>
              <Counter prefix="$" end={100} duration={2} suffix="K" /> Up to
            </span>
            <p>
              Financial Protection
            </p>
          </div>
        </motion.div>
      </div>
    </section >
  );
});

export default Statistics;
